import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { ArrowLeft } from 'lucide-react';
import { caseStudyPages } from '../data/caseStudyPages';
interface CaseStudyPageProps {
  slug: string;
}
export function CaseStudyPage({
  slug
}: CaseStudyPageProps) {
  const study = caseStudyPages.find(s => s.slug === slug);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [slug]);
  if (!study) {
    return <div className="min-h-[70vh] flex items-center justify-center text-secondary" data-id="element-80">
        Case study not found.
      </div>;
  }
  const handleBack = (e: React.MouseEvent) => {
    e.preventDefault();
    window.location.hash = '#/';
    setTimeout(() => {
      const workSection = document.getElementById('work');
      if (workSection) {
        workSection.scrollIntoView({
          behavior: 'smooth'
        });
      }
    }, 100);
  };
  return <motion.main initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.6
  }} className="pt-32 pb-32 px-6 md:px-12 max-w-4xl mx-auto" data-id="element-81">
      <button onClick={handleBack} className="flex items-center text-secondary hover:text-primary transition-colors mb-16 font-medium group" data-id="element-82">
        <ArrowLeft className="w-4 h-4 mr-2 group-hover:-translate-x-1 transition-transform" data-id="element-83" />
        Back to all work
      </button>

      {/* Header */}
      <header className="mb-20" data-id="element-84">
        <div className="flex items-center gap-2 text-sm text-secondary font-medium mb-6" data-id="element-85">
          <span className="text-primary" data-id="element-86">{study.company}</span>
          <span data-id="element-87">·</span>
          <span data-id="element-88">{study.timeframe}</span>
        </div>

        <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-primary tracking-tight mb-12 leading-tight" data-id="element-89">
          {study.headline}
        </h1>
      </header>

      {/* Body */}
      <div className="space-y-20" data-id="element-90">
        <section data-id="element-91">
          <h2 className="text-2xl md:text-3xl font-semibold text-primary mb-8 tracking-tight" data-id="element-92">
            Overview
          </h2>
          <p className="text-lg text-secondary leading-relaxed" data-id="element-93">
            {study.overview}
          </p>
        </section>

        <section data-id="element-94">
          <h2 className="text-2xl md:text-3xl font-semibold text-primary mb-8 tracking-tight" data-id="element-95">
            The Problem
          </h2>
          <p className="text-lg text-secondary leading-relaxed" data-id="element-96">
            {study.problem}
          </p>
        </section>

        <section data-id="element-97">
          <h2 className="text-2xl md:text-3xl font-semibold text-primary mb-8 tracking-tight" data-id="element-98">
            What I Built
          </h2>
          <p className="text-lg text-secondary leading-relaxed" data-id="element-99">
            {study.whatIBuilt}
          </p>
        </section>

        <section data-id="element-100">
          <h2 className="text-2xl md:text-3xl font-semibold text-primary mb-8 tracking-tight" data-id="element-101">
            Impact
          </h2>
          <ul className="space-y-6 text-lg text-secondary leading-relaxed list-disc pl-6 marker:text-gold" data-id="element-102">
            {study.impact.map((item, index) => <li key={index} className="pl-2" data-id="element-103">
                {item}
              </li>)}
          </ul>
        </section>

        {study.decision && <section data-id="element-104">
            <h2 className="text-2xl md:text-3xl font-semibold text-primary mb-8 tracking-tight" data-id="element-105">
              A Decision I Am Proud Of
            </h2>
            <p className="text-lg text-secondary leading-relaxed" data-id="element-106">
              {study.decision}
            </p>
          </section>}
      </div>
    </motion.main>;
}